import { useEffect } from 'react'

import { trackPageView } from '@snowplow/browser-tracker'
import { matchRoutes, useLocation } from 'react-router'

import * as routes from 'app/lib/routes'

const trackedRoutes = Object.values(routes)
  .filter((route) => 'pageViewTitle' in route)
  .map((route) => ({ path: route.path, pageViewTitle: route.pageViewTitle }))

const getPageViewTitle = (pathname: string): string | undefined => {
  // We need to use React Route MatchRoutes to avoid having: /members/add also fits /members/:eligibilityRecordId
  // (here 'add' would be considered a param)
  // MatchRoutes make exact paths like /members/add take priority over
  // dynamic routes like /members/:eligibilityRecordId
  const matches = matchRoutes(trackedRoutes, pathname)
  if (!matches) {
    return undefined
  }

  const [match] = matches
  return match.route.pageViewTitle
}

export const useTrackPageView = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    const title = getPageViewTitle(pathname)
    if (title) {
      trackPageView({ title })
    }
  }, [pathname])
}
